module.exports = __webpack_public_path__ + "static/media/compare.9e3cb8f8.svg";